import _compact from "lodash/compact";
import _castArray from "lodash/castArray";
function triggerOnKeys(fn, keyCodes) {
  var codes = _compact(_castArray(keyCodes));
  return function (e) {
    var key = e.which || e.keyCode;
    if (!codes.some(function (keyCode) {
      return keyCode == key;
    })) return;
    return fn(e);
  };
}
export default triggerOnKeys;